import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root",
})
export class ToasterService {
  private nileToast: any = new Subject<any>();
  nileToast$ = this.nileToast.asObservable();

  constructor(private translate: TranslateService) {}

  enableToast(message, type) {
    const nileToastInfo = {
      message: message,
      type: type,
    };
    this.nileToast.next(nileToastInfo);
  }

  error(message) {
    // Check if message is a translation key (contains dots and uppercase)
    const translatedMessage = this.isTranslationKey(message) ? 
      this.translate.instant(message) : message;
    this.enableToast(translatedMessage, "error");
  }

  success(message) {
    // Check if message is a translation key (contains dots and uppercase)
    const translatedMessage = this.isTranslationKey(message) ? 
      this.translate.instant(message) : message;
    this.enableToast(translatedMessage, "success");
  }

  warning(message) {
    // Check if message is a translation key (contains dots and uppercase)
    const translatedMessage = this.isTranslationKey(message) ? 
      this.translate.instant(message) : message;
    this.enableToast(translatedMessage, "warning");
  }

  info(message) {
    // Check if message is a translation key (contains dots and uppercase)
    const translatedMessage = this.isTranslationKey(message) ? 
      this.translate.instant(message) : message;
    this.enableToast(translatedMessage, "info");
  }

  private isTranslationKey(message: string): boolean {
    // Simple check: translation keys typically have dots and uppercase letters
    return typeof message === 'string' && message.includes('.') && /[A-Z]/.test(message);
  }
}
